import { render, staticRenderFns } from "./UploadTemplateSchoolForGroup.vue?vue&type=template&id=c5b35714&scoped=true"
import script from "./UploadTemplateSchoolForGroup.vue?vue&type=script&lang=js"
export * from "./UploadTemplateSchoolForGroup.vue?vue&type=script&lang=js"
import style0 from "./UploadTemplateSchoolForGroup.vue?vue&type=style&index=0&id=c5b35714&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5b35714",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5b35714')) {
      api.createRecord('c5b35714', component.options)
    } else {
      api.reload('c5b35714', component.options)
    }
    module.hot.accept("./UploadTemplateSchoolForGroup.vue?vue&type=template&id=c5b35714&scoped=true", function () {
      api.rerender('c5b35714', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FinanceVer2/ByGroup/TableSearchGroupDialog/UploadTemplateSchoolForGroup.vue"
export default component.exports